import { Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import {
  WorksheetBatchUpdateEquipmentDisplayField,
  WorksheetBatchUpdateEquipmentSelectionField,
} from 'Components/WorksheetBatchUpdate/Core';
import { WorksheetBatchUpdateWorksheetFieldSection } from 'Components/WorksheetBatchUpdate/types';
import React from 'react';
import { WorksheetBatchUpdateWorksheetField } from '../..';

export const IhmHandShearVaneWorksheetSections: {
  [name: string]: WorksheetBatchUpdateWorksheetFieldSection;
} = {
  preparation: {
    heading: 'Preparation',
  },
};

export const IhmHandShearVaneWorksheetFields: {
  [name: string]: WorksheetBatchUpdateWorksheetField;
} = {
  'data.Preparation.HandShearVane': {
    displayComponent: <WorksheetBatchUpdateEquipmentDisplayField />,
    entryComponent: <WorksheetBatchUpdateEquipmentSelectionField equipmentType="hand-shear-vane" />,
    displayFieldsWhenEntered: [
      'data.Preparation.BladeSize',
      'data.Preparation.CalibrationFactor',
      'data.Results.AverageVaneShearStrengthText',
    ],
    isImportSource: true,
    equipmentDetails: {
      calibrationImportMismatchField: 'data.Preparation.HandShearVaneCalibrationImportMismatch',
    },
    section: 'preparation',
  },
  'data.Preparation.BladeSize': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<RadioGroup />} />,
    displayFieldsWhenEntered: [
      'data.Preparation.HandShearVane',
      'data.Preparation.CalibrationFactor',
      'data.Results.AverageVaneShearStrengthText',
    ],
    section: 'preparation',
  },
  'data.Preparation.CalibrationFactor': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<NumericInput />} />,
    displayFieldsWhenEntered: ['data.Preparation.HandShearVane', 'data.Results.AverageVaneShearStrengthText'],
    section: 'preparation',
  },
  'data.Results.AverageVaneShearStrengthText': {
    displayComponent: <Field input={<TextOutput />} />,
  },
};

export default IhmHandShearVaneWorksheetFields;
